const VERTICAL_PAGE = 'Vertical Page';

export const MIXPANEL_EVENT_TITLES = {
    CLICKED_SUB_CATEGORY_LINK: `${VERTICAL_PAGE} - Clicked SC link`,
    CLICKED_BUCKET_EXPANDED: `${VERTICAL_PAGE} - Clicked bucket expanded`,
    CLICKED_BUCKET_COLLAPSED: `${VERTICAL_PAGE} - Clicked bucket collapsed`,
    CLICKED_HOW_FIVERR_WORKS: 'How Fiverr Works video in Category',
    CLICKED_POPULAR_CAROUSEL_ITEM: `${VERTICAL_PAGE} - Clicked Popular Carousel Item`,
    CLICKED_FAQ_EXPANDED: `${VERTICAL_PAGE} - Clicked FAQ Expanded`,
    CLICKED_FAQ_COLLAPSED: `${VERTICAL_PAGE} - Clicked FAQ Collapsed`,
    CLICKED_FLP_LINK: `${VERTICAL_PAGE} - Clicked FLP link`,
};

export const EVENT_TYPES = {
    CLICKED_SUB_CATEGORY_LINK: 'CLICKED_SUB_CATEGORY_LINK',
    CLICKED_BUCKET_EXPANDED: 'CLICKED_BUCKET_EXPANDED',
    CLICKED_BUCKET_COLLAPSED: 'CLICKED_BUCKET_COLLAPSED',
    CLICKED_HOW_FIVERR_WORKS: 'CLICKED_HOW_FIVERR_WORKS',
    CLICKED_POPULAR_CAROUSEL_ITEM: 'CLICKED_POPULAR_CAROUSEL_ITEM',
    CLICKED_FAQ_EXPANDED: 'CLICKED_FAQ_EXPANDED',
    CLICKED_FAQ_COLLAPSED: 'CLICKED_FAQ_COLLAPSED',
    CLICKED_FLP_LINK: 'CLICKED_FLP_LINK',
};
